import { ConnectionDetails, convertConnectionToDetails, mergeConnectionDetails as merge } from '@/utils/custom';
import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  IncidentIssueDocument,
  IncidentIssueDocumentSearch,
  SearchIncidentIssueDocumentResponseIncidentIssueDocumentConnectionArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { SearchIncidentIssueDocument } from '@/features/IncidentHistory/api/queries/SearchIncidentIssueDocument';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof IncidentIssueDocumentSearch]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<IncidentIssueDocument>>;
}

// SearchIncidentIssueDocument Service
export const { searchIncidentIssueDocument, refetchIncidentIssueDocument, useIncidentIssueDocument } = ((): {
  searchIncidentIssueDocument: ServiceMethod;
  refetchIncidentIssueDocument: ServiceMethod;
  useIncidentIssueDocument: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch, refetch] = graphApi(SearchIncidentIssueDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<IncidentIssueDocument>> => {
        const args: SearchIncidentIssueDocumentResponseIncidentIssueDocumentConnectionArgs = {
          input: {
            first: options?.pageSize || null,
            after: options?.pageSize > 0 ? (options?.pageSize * options?.page).toString() : null,
            query: payload,
          },
        };
        const opts = { merge: options?.merge ? 'searchIncidentIssueDocument.incidentIssueDocumentConnection' : undefined };
        const res = await fn(args, opts);
        return convertConnectionToDetails(getProperty('searchIncidentIssueDocument.incidentIssueDocumentConnection', res));
      }
  );
  const useService = createGraphApiHook(fetch, { refetch, merge });
  return {
    searchIncidentIssueDocument: fetch,
    refetchIncidentIssueDocument: refetch,
    useIncidentIssueDocument: useService,
  };
})();
